import { Outlet, useMatch } from "react-router-dom";
import Navbar from "./Navbar";

const Layout = ({ children }) => {
  const match = useMatch("/admin/*");

  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div
          className={`${
            match !== null
              ? "max-w-full px-5 lg:px-20"
              : "mx-auto max-w-7xl px-5 lg:px-0"
          }`}
        >
          <Outlet />
        </div>
      </section>
    </>
  );
};

export default Layout;
